import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "@phosphor-icons/react";

/**
 * LanguageToggle — EN / ES switch. Persists via i18next (localStorage 'cf_lang')
 * and reflects the choice in the URL (?lang=) so shared links keep the language.
 */
export default function LanguageToggle({ className = "", compact = false }) {
    const { i18n } = useTranslation();
    const current = (i18n.language || "en").split("-")[0];

    const change = (lng) => {
        const cur = (i18n.language || "en").split("-")[0];
        if (lng === cur) return;
        try {
            const url = new URL(window.location.href);
            url.searchParams.set("lang", lng);
            window.history.replaceState({}, "", url);
        } catch { /* noop */ }
        i18n.changeLanguage(lng);
        try { localStorage.setItem("cf_lang_explicit", "1"); } catch { /* noop */ }
        // Reload so the AI auto-translation layer re-runs cleanly from source
        // (EN) and the whole page reflects the chosen language consistently.
        window.location.reload();
    };

    const langs = [
        { code: "en", label: "EN" },
        { code: "es", label: "ES" },
    ];

    return (
        <div className={`inline-flex items-center gap-1 ${className}`} data-testid="language-toggle">
            {!compact && <Globe size={16} className="opacity-60 mr-0.5" aria-hidden />}
            {langs.map((l, i) => (
                <React.Fragment key={l.code}>
                    {i > 0 && <span className="opacity-30 text-xs">/</span>}
                    <button
                        type="button"
                        onClick={() => change(l.code)}
                        aria-pressed={current === l.code}
                        data-testid={`lang-${l.code}`}
                        className={`text-xs font-bold tracking-wider transition-opacity ${current === l.code ? "opacity-100 underline underline-offset-4" : "opacity-50 hover:opacity-90"}`}
                    >
                        {l.label}
                    </button>
                </React.Fragment>
            ))}
        </div>
    );
}
